import { useQuery } from "react-query";
import client from "../../../../../../apollo/apolloClient";
import ApolloWhatsappTemplates from "../../../../../../apollo/apolloWhatsappTemplates";

/**
 * Checks if a template with the given `name` already exists in the `channelId`.
 * Only activates when both parameters are valid and have at least 3 chars.
 */
export const useCheckTemplateName = (channelId, name) => {
  return useQuery(
    ["template-name-check", channelId, name],
    async () => {
      const response = await client.query({
        query: ApolloWhatsappTemplates.GET_TEMPLATE_BY_NAME_AND_CHANNEL,
        variables: { channelId, name },
        fetchPolicy: "network-only",
      });

      return response.data.whatsappTemplates ?? [];
    },
    {
      enabled: !!channelId && !!name && name.length >= 3,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchInterval: false,
      retry: false,
    },
  );
};
